import { render, staticRenderFns } from "./cpt-scroll-table.vue?vue&type=template&id=2ca537b3&scoped=true"
import script from "./cpt-scroll-table.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-table.vue?vue&type=script&lang=js"
import style0 from "./cpt-scroll-table.vue?vue&type=style&index=0&id=2ca537b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca537b3",
  null
  
)

export default component.exports